// extracted by mini-css-extract-plugin
module.exports = {"bgImg":"backgroundImage-module--bgImg--3t789"};